module.exports = __webpack_public_path__ + "static/image/company/pc/image_declaration@3x.jpg?5650de32";